<template>
  <i-dx-popup :popupVisible="popupVisible" :title="title" @popupCloseButtonClick="closeBtn" @showing="onPopup" height="100vh" width="80vw">
    <template v-slot:grid>
      <div class="v-application" style="display: block !important; ">
        <v-row no-gutters class="px-6">
          <v-col cols="4" class="pr-2 d-flex flex-column" height="100%">
            <v-card width="100%" color="inner_card_bg" flat class="py-3 px-4 rounded">
              <div class="card-sub-title">현재 적용된 양식</div>
              <div class="card-title">{{ currntDiv && currntDiv.dataDivNm }}</div>
              <div class="card-title-code">{{ currntDiv && currntDiv.dataDiv }}</div>
            </v-card>
            <v-card color="inner_card_bg" flat height="calc(100vh - 268px)" class="pa-4 mt-2 rounded overflow-y-auto">
              <v-list class="popup-card-list">
                <v-list-item-group v-model="selectedIndex" mandatory color="primary">
                  <v-list-item v-for="(item, index) in dataDivList" :key="index" :class="{ selected: index === selectedIndex }" outlined>
                    <v-list-item-content>
                      <v-text-field
                        dense
                        hide-details="auto"
                        solo
                        spellcheck="false"
                        :disabled="item.clntId == 'COMMON'"
                        v-model="item.dataDivNm"
                      ></v-text-field>
                      <v-list-item-subtitle>{{ item.dataDiv }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="ml-2">
                      <v-btn
                        color="primary"
                        elevation="0"
                        small
                        outlined
                        height="30px"
                        class="rounded"
                        :disabled="(item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag)"
                        @click="btnDivApply(item)"
                      >
                        <span>
                          {{ (item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag) ? '적용중' : '적용' }}
                        </span>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <div class="btn-wrap mt-2" @click="onFocusedRowChanged">
              <v-btn color="error" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnDivDelete()">
                <span>삭제</span>
              </v-btn>
              <v-btn color="primary" elevation="0" large outlined class="rounded" @click="btnDivAdd()">
                <span>추가</span>
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <!-- <v-icon small color="primary" style="position: absolute; right: 5px;" v-on="on">mdi-information-outline</v-icon> -->
                    <svg-icon icon-class="info" style="height: 1rem; position: absolute; right: 5px;" v-on="on" />
                  </template>
                  <div class="tooltip-text">{{ '빈 양식을 생성하여 사용자가 항목을 설정합니다.' }}</div>
                </v-tooltip>
              </v-btn>
              <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="!selectedDiv" @click="btnDivCopy()">
                <span>복사</span>
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <!-- <v-icon small color="primary" style="position: absolute; right: 5px;" v-on="on">mdi-information-outline</v-icon> -->
                    <svg-icon icon-class="info" style="height: 1rem; position: absolute; right: 5px;" v-on="on" />
                  </template>
                  <div class="tooltip-text">{{ '현재 선택된 양식을 복사하여 추가/수정/삭제하여 사용합니다.' }}</div>
                </v-tooltip>
              </v-btn>
              <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnDivSave()">
                <span>저장</span>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="8" class="pl-2" height="100%">
            <i-card-vertical headerTitle="구분" device="web" :IsUseInnerAddition="true" :onlyGrid="true" contentsClass="popup-grid-card">
              <template v-slot:innerAddition>
                <div class="btn-wrap ml-2">
                  <v-btn color="error" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnMainDelete()">
                    <span>삭제</span>
                  </v-btn>
                  <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnMainAdd()">
                    <span>추가</span>
                  </v-btn>
                  <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnMainSave()">
                    <span>저장</span>
                  </v-btn>
                </div>
              </template>
              <template v-slot:body>
                <DxDataGrid
                  key-expr="seq"
                  width="100%"
                  height="calc((100vh - 280px)/2)"
                  :ref="dxDataGridMainRef"
                  :data-source="gridMain"
                  :focused-row-enabled="true"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :column-auto-width="false"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-index.sync="focusedRowIndexMain"
                  @focused-row-changed="onFocusedRowChanged"
                  @editor-preparing="
                    e => {
                      onEditorPreparing(e)
                    }
                  "
                >
                  <!-- 컬럼 정의 -->
                  <DxEditing mode="batch" :allow-updating="!btnDisabled" :select-text-on-edit-start="true" />
                  <DxColumn data-field="clntId" data-type="string" :visible="false" />
                  <DxColumn data-field="seq" data-type="string" alignment="center" caption="번호" :allow-editing="false" width="50px" />
                  <DxColumn data-field="budgetDivNm" data-type="string" caption="구분" css-class="devest-grid-header-require" />
                </DxDataGrid>
              </template>
            </i-card-vertical>
            <i-card-vertical
              headerTitle="구분별 항목"
              device="web"
              :IsUseInnerAddition="true"
              :onlyGrid="true"
              contentsClass="popup-grid-card"
              class="mt-5"
            >
              <template v-slot:innerAddition>
                <div class="btn-wrap ml-2">
                  <v-btn color="error" elevation="0" large outlined class="rounded" :disabled="btnDisabledDetail" @click="btnDetailDelete()">
                    <span>삭제</span>
                  </v-btn>
                  <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabledDetail" @click="btnDetailAdd()">
                    <span>추가</span>
                  </v-btn>
                  <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabledDetail" @click="btnDetailSave()">
                    <span>저장</span>
                  </v-btn>
                </div>
              </template>

              <template v-slot:body>
                <DxDataGrid
                  key-expr="seq"
                  width="100%"
                  height="calc((100vh - 280px)/2)"
                  :ref="dxDataGridDetailRef"
                  :data-source="gridDetail"
                  :focused-row-enabled="true"
                  :focused-row-index.sync="focusedRowIndexDetail"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :column-auto-width="false"
                  :show-borders="true"
                  :show-row-lines="true"
                  @editor-preparing="
                    e => {
                      onEditorPreparing(e)
                      onEditorPreparingExtra(e)
                    }
                  "
                >
                  <DxEditing mode="batch" :allow-updating="!btnDisabled" :select-text-on-edit-start="true" />
                  <!-- 컬럼 정의 -->
                  <DxColumn data-field="seq" data-type="string" alignment="center" caption="번호" :allow-editing="false" width="50px" />
                  <DxColumn data-field="budgetDivItemNm" data-type="string" caption="항목" css-class="devest-grid-header-require"></DxColumn>
                </DxDataGrid>
              </template>
            </i-card-vertical>
          </v-col>
        </v-row>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import IDxPopup from '@/components/common/iDxPopup.vue'
import { getGroupData } from '@/api/setting/groupManage'
import {
  getSHBudgetDivList,
  getSHBudgetDivItemList,
  saveSHBudgetDataDiv,
  saveSHBudgetDiv,
  saveSHBudgetDivItem,
  deleteSHBudgetDataDiv,
  deleteSHBudgetDiv,
  deleteSHBudgetDivItem,
  applySHBudgetDataDiv,
  copySHBudgetDataDiv
} from '@/api/leaderShip/shbudgetManage_new.js'
export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      dataDivList: [],
      selectedIndex: null,
      dxDataGridMainRef: 'dataDivMain',
      dxDataGridDetailRef: 'dataDivDetail',
      gridMain: [],
      focusedRowIndexMain: -1,
      focusedRowDataMain: null,
      gridDetail: [],
      focusedRowIndexDetail: -1,
      authList: [],
      btnMainDisabled: false
    }
  },
  computed: {
    selectedDiv() {
      return this.dataDivList.length && Number.isInteger(this.selectedIndex) ? this.dataDivList[this.selectedIndex] : null
    },
    btnDisabled() {
      return !this.selectedDiv || this.selectedDiv.clntId == 'COMMON' || this.btnMainDisabled
    },
    btnDisabledDetail() {
      return this.btnDisabled || !this.focusedRowDataMain || this.focusedRowDataMain.__created__
    },
    currntDiv() {
      return this.dataDivList.length && this.dataDivList.findLast(e => e.finalUse == 'Y')
    },
    // 기본항목 적용/적용중 플래그값 생성
    basicApplyFlag() {
      return !this.dataDivList.some(el => el.clntId != 'COMMON' && el.finalUse == 'Y')
    }
  },
  watch: {
    selectedIndex: function(index) {
      this.initializeGrids()
      if (Number.isInteger(index)) {
        this.updateGridData(index)
      } else {
        this.gridMain = []
      }
    }
  },
  beforeMount() {
    Promise.all([getGroupData()]).then(response => {
      let failedResponse = response.find(element => !element.success)
      if (failedResponse == null) {
        this.authList = response[0].list.filter(auth => auth.clientYn == 'Y')
        // grpAuthCd, grpAuthNm
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'error')
      }
    })
  },
  methods: {
    onPopup(e) {
      this.searchDataDiv(true)
    },
    // 그리드 초기화
    initializeGrids() {
      this.gridDetail = []
      this.gridInit(this.GetDataGrid(this.dxDataGridMainRef))
      this.gridInit(this.GetDataGrid(this.dxDataGridDetailRef))
      this.focusedRowIndexMain = 0
      this.focusedRowIndexDetail = 0
      this.focusedRowDataMain = null
      this.focusedRowDataDetail = null
      // console.log('div선택', this.selectedIndex)
      // console.log('Main선택', this.focusedRowIndexMain)
      // console.log('Detail선택', this.focusedRowIndexDetail)
    },
    // 그리드 데이터를 인덱스에 따라 업데이트
    updateGridData(index) {
      this.gridMain = this.dataDivList[index].divList.slice()
      if (this.dataDivList[index].divList.length < 1) {
        this.gridDetail = []
      }
    },

    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    },
    searchDataDiv(isNotify) {
      // this.selectedIndex = null
      if (!this.selectedIndex) {
        this.selectedIndex = null
      }
      this.dataDivList = []
      this.openLoading()
      getSHBudgetDivList(
        {
          clntId: this.getClntId(),
          compId: this.getCompId()
        },
        isNotify
      )
        .then(res => {
          this.dataDivList = _.clone(res.list)
          this.gridMain = []
          this.gridDetail = []
          this.selectedIndex = 0
          if (this.dataDivList[0].divList.length > 0) {
            this.focusedRowDataMain = _.clone(this.dataDivList[0].divList[0])
            // this.getDetail(false)
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivAdd() {
      this.openLoading()
      const currentDate = this.getCurrentDate()
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: currentDate,
        dataDivNm: `${currentDate.substring(0, 4)}년 ${currentDate.substring(4, 6)}월 ${currentDate.substring(6, 8)}일 안전보건 예산 양식`,
        finalUse: 'N',
        divList: [],
        __created__: true
      }
      saveSHBudgetDataDiv(params)
        .then(res => {
          params.dataDiv = res.dataDiv
          //배열의 앞에 새 항목을 추가
          this.dataDivList.unshift(params)
          //배열 젤 앞에 포커스
          this.selectedIndex = 0
          // 추가된 그리드 초기화
          this.gridMain = []
          this.gridDetail = []
          this.searchDataDiv(true)
          this.focusedRowDataMain = _.clone(this.dataDivList[this.selectedIndex].divList[0])
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.getDetail(false)
          this.endLoading()
        })
    },
    btnDivCopy() {
      this.openLoading()
      const currentDate = this.getCurrentDate()
      let params = {
        clntId: this.getClntId(),
        writeDt: currentDate,
        dataDivNm: `${currentDate.substring(0, 4)}년 ${currentDate.substring(4, 6)}월 ${currentDate.substring(6, 8)}일 안전보건 예산 양식`,
        clntIdCopy: this.selectedDiv.clntId,
        dataDivCopy: this.selectedDiv.dataDiv,
        createdBy: this.getUserCd(),
        divList: [],
        __created__: true
      }
      copySHBudgetDataDiv(params)
        .then(response => {
          this.dataDivList.unshift(params)
          this.selectedIndex = 0
          this.searchDataDiv(true)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 양식 저장
    btnDivSave() {
      console.log('## this.selectedDiv', this.selectedDiv)
      this.vToastifyPrompt(this.$t('doSaveData'), 'info', current => {
        let params = {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          dataDiv: this.selectedDiv.dataDiv,
          dataDivNm: this.selectedDiv.dataDivNm,
          divList: [],
          finalUse: this.selectedDiv.finalUse,
          __created__: false
        }
        this.openLoading()
        saveSHBudgetDataDiv(params)
          .then(res => {
            console.log('###res', res)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    //양식 삭제
    btnDivDelete() {
      this.openLoading()
      deleteSHBudgetDataDiv(
        {
          clntId: this.selectedDiv.clntId,
          dataDiv: this.selectedDiv.dataDiv,
          createdBy: this.getUserCd()
        },
        true
      )
        .then(response => {
          this.selectedIndex = null
          this.searchDataDiv(true)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivApply(div) {
      console.log('적용', div)
      if (div.divList < 1) {
        return this.vToastify(this.$t('적용할 항목이 없습니다.'), 'warn')
      }
      this.openLoading('saving')
      applySHBudgetDataDiv(
        {
          clntId: this.getClntId(),
          dataDiv: div.clntId == 'COMMON' ? 'COMMON' : div.dataDiv
        },
        false
      )
        .then(response => {
          // this.selectedIndex = null
          this.dataDivList = response.list
          this.searchDataDiv(true)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnMainAdd() {
      let newRow = {
        id: this.selectedDiv.dataDiv + '_' + this.gridMain.length,
        clntId: this.getClntId(),
        dataDiv: this.selectedDiv.dataDiv,
        budgetDivNm: '',
        delYn: 'N',
        seq: this.gridMain.length + 1,
        __created__: true
      }
      this.GetDataGrid(this.dxDataGridMainRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridMainRef).selectRows(newRow.id, true)

      console.log('메인 추가 버튼', this.focusedRowDataMain)
    },

    //구분 저장
    async btnMainSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridMainRef).saveEditData()
      console.log('구분 저장', selectedRows)
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridMainRef).beginUpdate()
          this.openLoading()
          saveSHBudgetDiv(selectedRows, true)
            .then(res => {
              console.log('결과값', res)
              this.searchDataDiv(false)
              this.gridInit(this.GetDataGrid(this.dxDataGridMainRef))
              this.gridInit(this.GetDataGrid(this.dxDataGridDetailRef))
              this.focusedRowDataMain.__created__ = false // 예시로 __created__ 값을 변경

              // this.onFocusedRowChanged();
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridMainRef).endUpdate()

              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnMainDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridMainRef).saveEditData()
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridMainRef).beginUpdate()
          this.openLoading('deleting')
          deleteSHBudgetDiv(
            selectedRows
              .filter(element => !element.__created__)
              .map(e => {
                e.createdBy = this.getUserCd()
                return e
              }),
            true
          )
            .then(res => {
              this.gridMain = res.list
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    btnDetailAdd() {
      let newRow = {
        id: this.selectedDiv.dataDiv + '_' + this.gridDetail.length,
        clntId: this.getClntId(),
        dataDiv: this.selectedDiv.dataDiv,
        budgetDiv: this.focusedRowDataMain.budgetDiv,
        delYn: 'N',
        seq: this.gridDetail.length + 1,
        createdBy: this.getUserCd(),
        __created__: true
      }
      this.GetDataGrid(this.dxDataGridDetailRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridDetailRef).selectRows(newRow.id, true)
    },

    //구분 항목 저장
    async btnDetailSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridDetailRef).saveEditData()
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridDetailRef).beginUpdate()
          this.openLoading()
          saveSHBudgetDivItem(selectedRows, true)
            .then(res => {
              this.selectedIndex = null
              this.searchDataDiv(false)
              this.getDetail(false)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridDetailRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    getDetail(isNotify) {
      this.gridDetail = []
      let data = this.focusedRowDataMain
      // console.log('조회 getDetail ==> ', this.focusedRowDataMain)
      if (this.focusedRowDataMain) {
        this.openLoading()
        getSHBudgetDivItemList(this.focusedRowDataMain, isNotify)
          .then(res => {
            this.gridInit(this.GetDataGrid(this.dxDataGridMainRef))
            this.gridInit(this.GetDataGrid(this.dxDataGridDetailRef))
            this.gridDetail = res.list
            this.focusedRowIndexDetail = this.gridDetail.length ? 0 : -1
          })
          .finally(() => {
            if (this.gridMain.length < 1) {
              this.gridDetail = []
            }
            this.endLoading()
          })
      } else {
        this.gridDetail = []
      }
    },
    async btnDetailDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridDetailRef).saveEditData()
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridDetailRef).beginUpdate()
          this.openLoading('deleting')
          deleteSHBudgetDivItem(
            selectedRows
              .filter(element => !element.__created__)
              .map(e => {
                e.createdBy = this.getUserCd()
                return e
              }),
            true
          )
            .then(res => {
              this.getDetail(false)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridDetailRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    closeBtn() {
      this.selectedIndex = null
      this.gridMain = []
      this.gridDetail = []
      this.$emit('popupClose')
    },
    ///////////////////////////////////////
    /*         DataGrid   Event          */
    ///////////////////////////////////////

    onEditorPreparingExtra(e) {},

    onFocusedRowChanged(e) {
      // console.log('클릭M', this.focusedRowIndexMain)
      // console.log('클릭D', this.focusedRowIndexDetail)
      // console.log('클릭Data', this.focusedRowDataMain)
      this.focusedRowDataMain = e.row && e.row.data
      if (this.focusedRowDataMain && !this.focusedRowDataMain.__created__) {
        this.getDetail(true)
      } else {
        this.gridDetail = []
        this.focusedRowIndexDetail = -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
  display: flex;
  gap: 8px;
  .v-btn {
    flex: 1 1 auto;
    min-width: unset;
    padding: 0 16px;
  }
}
.card-sub-title {
  color: #3e3e3f;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: normal;
}
.card-title {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: normal;
  padding: 16px 0 4px;
}
.card-title-code {
  color: #babbbb;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
